import type { GridRowId } from "@mui/x-data-grid-premium";

export const getSelectionLimitMessage = (limit: number): string => `You can select up to ${limit} values.`;

export const isSelectionWithinLimit = (values: Iterable<GridRowId>, limit: number): boolean =>
  new Set(values).size <= limit;

export const isSelectAllChecked = (
  selectedValues: ReadonlySet<GridRowId>,
  resultValues: Iterable<GridRowId>,
  limit: number
): boolean => {
  if (selectedValues.size >= limit) {
    return true;
  }

  let hasValues = false;
  for (const value of resultValues) {
    hasValues = true;
    if (!selectedValues.has(value)) {
      return false;
    }
  }
  return hasValues;
};

export const getSelectionUpToLimit = (
  selectedValues: Iterable<GridRowId>,
  valuesToSelect: Iterable<GridRowId>,
  limit: number
): GridRowId[] => {
  const selection = new Set(selectedValues);
  for (const value of valuesToSelect) {
    if (selection.size >= limit) {
      break;
    }
    selection.add(value);
  }
  return [...selection];
};

export const wouldExceedSelectionLimit = (
  selectedValues: Iterable<GridRowId>,
  valuesToSelect: Iterable<GridRowId>,
  limit: number
): boolean => {
  const values = new Set(selectedValues);
  let hasNewValues = false;
  for (const value of valuesToSelect) {
    if (!values.has(value)) {
      values.add(value);
      hasNewValues = true;
    }
  }
  return hasNewValues && values.size > limit;
};
